import { concat } from 'lodash';
import React, { FC } from 'react';
import { useApplication } from 'src/context/ApplicationContext';
import { ALS_ERLEDIGT_MARKIEREN_LABEL, PLATZHALTER_TEXT } from 'src/lib/constants/constant';
import { FormStrucItem } from 'src/lib/types/types';
import { ForceTrue } from 'src/lib/validation/ValidationTypes';
import PruefAssistenz from 'src/pages/private/online-antrag/antrag-components/PruefAssistenz';
import ApplicationHeading from 'src/pages/private/online-antrag/application-heading/ApplicationHeading';
import { checkIfPruefAssitenzNeedsToValidate } from 'src/pages/private/online-antrag/application-helper-function/AppHelperfunctions';

// import schemas
import AntragSchema from 'src/lib/paths/antrag_FULL_Paths.json';
const P = AntragSchema.attributes;

const AnlagenPruefAssistenzGlobal: FC<{ showHeading?: boolean }> = ({ showHeading = true }) => {
	const { application } = useApplication();

	return (
		<>
			{showHeading && <ApplicationHeading title='Anlagen' description={PLATZHALTER_TEXT} />}
			<PruefAssistenz
				statusPath={P.Pruefung_Anlagen_Pruefstatus.path}
				hinweisPath={P.Pruefung_Anlagen_Hinweis_Fuer_Den_Antragsteller.path}
				ueberarbeitetAmPath={P.Pruefung_Anlagen_Ueberarbeitet_Am.path}
				erledigtPath={P.Pruefung_Anlagen_Erledigt.path}
				formStruc={formStrucPruefAssistenz(application)}
			/>
		</>
	);
};

export default AnlagenPruefAssistenzGlobal;

const formStrucPruefAssistenz = (_application: any) => {
	let struc: FormStrucItem[] = [
		{
			fields: [
				{
					...P.Pruefung_Anlagen_Erledigt,
					label: ALS_ERLEDIGT_MARKIEREN_LABEL,
					validation: [{ validateFunction: ForceTrue }],
				},
			],
		},
	];

	return struc;
};

export const getFormStrucAnlagenPruefAssistenzGlobal = (application: any) => {
	let result: FormStrucItem[] = [];

	if (checkIfPruefAssitenzNeedsToValidate(application, P.Pruefung_Anlagen_Pruefstatus.path, P.Pruefung_Anlagen_Erledigt.path)) {
		result = concat(formStrucPruefAssistenz(application), result);
	}
	return result;
};
